/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnalyzeSetRequest
 */
export interface AnalyzeSetRequest {
    /**
     * Art der Analyse
     * @type {string}
     * @memberof AnalyzeSetRequest
     */
    analyzeType: AnalyzeSetRequestAnalyzeTypeEnum;
}


/**
 * @export
 */
export const AnalyzeSetRequestAnalyzeTypeEnum = {
    Simple: 'SIMPLE',
    Protected: 'PROTECTED',
    All: 'ALL',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type AnalyzeSetRequestAnalyzeTypeEnum = typeof AnalyzeSetRequestAnalyzeTypeEnum[keyof typeof AnalyzeSetRequestAnalyzeTypeEnum];


/**
 * Check if a given object implements the AnalyzeSetRequest interface.
 */
export function instanceOfAnalyzeSetRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "analyzeType" in value;

    return isInstance;
}

export function AnalyzeSetRequestFromJSON(json: any): AnalyzeSetRequest {
    return AnalyzeSetRequestFromJSONTyped(json, false);
}

export function AnalyzeSetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalyzeSetRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'analyzeType': json['analyzeType'],
    };
}

export function AnalyzeSetRequestToJSON(value?: AnalyzeSetRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'analyzeType': value.analyzeType,
    };
}

